{
  "version": 1,
  "asset_id": "a578d40a-c200-4042-96c0-8daad079fd99",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a578d40a-c200-4042-96c0-8daad079fd99/dilated-pouch-boxed-es-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a578d40a-c200-4042-96c0-8daad079fd99/dilated-pouch-boxed-es-800.jpg",
  "original_filename": "dilated-pouch-boxed-es-800.jpg",
  "size": 106275,
  "content_type": "image/jpeg",
  "created_at": "2026-10-06T14:09:12Z"
}
